<template>
    <div>
        <v-form
                ref="queryForm"
        >
            <v-row
                    justify="center"
                    align="center"
            >

                <v-col
                        cols="2"
                        xs="4"
                >
                    <v-text-field
                            clearable
                            v-model="queryData.nodeName"
                            label="节点名称"
                            single-line
                            clearable
                    ></v-text-field>
                </v-col>


                <v-col
                        cols="6"
                        md="4"
                        xs="12"
                >
                    <v-btn
                            class="ma-2"
                            color="primary"
                            @click="addNode">
                        添加主节点
                    </v-btn>
                    <v-btn color="primary" @click="addChildNode">增加子节点</v-btn>
                    <!--<v-btn color="primary" class="ma-2" @click="updateNode">修改节点</v-btn>-->
                </v-col>

            </v-row>
        </v-form>
        <v-row justify="center">
            <v-col :cols="8">

                <v-treeview
                        class="ml-12 mr-12"
                        v-model="treeKeyList"
                        activatable
                        dense
                        item-key="id"
                        item-text="nodeName"
                        item-children="childNodeList"
                        :items="treeList"
                        return-object
                        @update:active="updateActiveKey"
                        :search="queryData.nodeName"
                        :filter="filter"
                        :open="open"
                        open-all
                >
                    <template v-slot:append="{ item, open }">

                        <v-btn text color="primary"
                               @click="updateNode(item)"
                               v-if="item.nodeType!='01'&&item.nodeType!='02'&&item.nodeType!='03'">修改
                        </v-btn>

                        <v-btn text color="primary"
                               @click="removeNode(item)"
                               v-if="item.nodeType=='04'">删除
                        </v-btn>

                    </template>
                </v-treeview>

            </v-col>
        </v-row>

        <!--<v-btn color="primary" class="ml-12 mr-12" @click="showNodeDetail">详情</v-btn>-->

        <!--节点增加弹框 start-->
        <v-dialog
                @click:outside="closeAddDialog"
                v-model="dialog.addNode"
                width="90%">
            <template>
                <v-stepper v-model="stepIndex">
                    <v-stepper-header>
                        <v-stepper-step :complete="stepIndex > 1" step="1">选择节点类型</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="stepIndex > 2" step="2">配置节点详情</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3">结果</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1" class="text-center">
                            <v-card
                                    style="width:95%"
                                    class="mx-auto ma-4"
                            >
                                <v-card-title>
                                    {{parentNodeDesc}}
                                </v-card-title>
                                <v-card-text>
                                    <v-form ref="chooseNodeTypeForm">
                                        <v-row align="center" justify="center">
                                            <v-col
                                                    class="text-left flex-view-style"
                                                    align-self="start"
                                                    cols="4">

                                                <z-source-selector
                                                        :label="'节点类型'"
                                                        :rules="[v => !!v||'请选择节点类型']"
                                                        v-model="nodeType"
                                                        :initLoad="false"
                                                        :itemsList="nodeTypeList">
                                                </z-source-selector>

                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-text>
                            </v-card>

                            <v-btn
                                    color="primary"
                                    @click="goNodeDetail"
                            >
                                下一步
                            </v-btn>

                            <v-btn @click="dialog.addNode=false">取消</v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="2" class="text-center">
                            <v-card
                                    style="width:95%"
                                    class="mx-auto ma-4"
                                    v-if="stepIndex==2"
                            >
                                <v-card-title>
                                    {{parentNodeDesc}}
                                </v-card-title>

                                <!--省添加地理位置 start-->
                                <div v-if="nodeType=='01'">
                                    <v-card-text>
                                        <v-form
                                                ref="areaForm">
                                            <v-row>
                                                <v-col
                                                        :cols="4">
                                                    <z-source-selector
                                                            :rules="[v => !!v || '省一级必选']"
                                                            :label="'省级'"
                                                            v-model="areaListData.province"
                                                            source="ProvinceSelector"
                                                    >
                                                    </z-source-selector>
                                                </v-col>
                                                <v-col
                                                        :cols="4">

                                                    <z-source-selector
                                                            :label="'市级'"
                                                            source="CitySelector"
                                                            :param="areaListData.province"
                                                            v-model="areaListData.city"
                                                    >
                                                    </z-source-selector>

                                                </v-col>
                                                <v-col
                                                        :cols="4">

                                                    <z-source-selector
                                                            :label="'县级'"
                                                            source="DistrictSelector"
                                                            :param="areaListData.city"
                                                            v-model="areaListData.district"

                                                    >
                                                    </z-source-selector>
                                                </v-col>
                                            </v-row>
                                        </v-form>

                                    </v-card-text>
                                </div>
                                <!--省添加地理位置 end-->

                                <!--市添加地理位置 start-->
                                <div v-if="nodeType=='02'">
                                    <v-card-text>
                                        <v-form
                                                ref="areaForm">
                                            <v-row>
                                                <v-col
                                                        :cols="4">

                                                    <z-source-selector
                                                            :rules="[v => !!v || '市一级必选']"
                                                            :label="'市级'"
                                                            source="CitySelector"
                                                            :param="areaListData.province"
                                                            v-model="areaListData.city"
                                                    >
                                                    </z-source-selector>

                                                </v-col>
                                                <v-col
                                                        :cols="4">

                                                    <z-source-selector
                                                            :label="'县级'"
                                                            source="DistrictSelector"
                                                            :param="areaListData.city"
                                                            v-model="areaListData.district"
                                                    >
                                                    </z-source-selector>

                                                </v-col>
                                            </v-row>
                                        </v-form>

                                    </v-card-text>
                                </div>
                                <!--市添加地理位置 end-->

                                <!--区添加地理位置 start-->
                                <div v-if="nodeType=='03'">
                                    <v-card-text>
                                        <v-form
                                                ref="areaForm">
                                            <v-row>
                                                <v-col
                                                        :cols="4">

                                                    <z-source-selector
                                                            :rules="[v => !!v || '区一级必选']"
                                                            :label="'区级'"
                                                            source="DistrictSelector"
                                                            :param="areaListData.city"
                                                            v-model="areaListData.district"
                                                    >
                                                    </z-source-selector>
                                                </v-col>
                                            </v-row>
                                        </v-form>

                                    </v-card-text>
                                </div>
                                <!--区添加地理位置 end-->

                                <!--添加医院类型 start-->
                                <div v-if="nodeType=='04'">
                                    <v-card-text>
                                        <v-form
                                                ref="queryHospForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >

                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryHospData.hospName"
                                                            label="医院名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>


                                                <v-btn
                                                        color="primary"
                                                        :loading="loading.queryHospRequest"
                                                        @click="handleHospQuery"
                                                >
                                                    搜索
                                                    <v-icon right>mdi-magnify</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        color="primary"
                                                        class="ma-2"
                                                        @click="resetHospQuery"
                                                >
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>

                                            </v-row>
                                        </v-form>
                                        <v-row justify="center">
                                            <v-data-table
                                                    :options.sync="hosplistOptions"
                                                    :server-items-length="hospTotal"
                                                    v-model="selectHospId"
                                                    :headers="hospHeaders"
                                                    :items="dataTable.hospList"
                                                    :single-select="true"
                                                    item-key="id"
                                                    show-select
                                                    class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <!--添加医院类型 end-->

                                <!--添加科室 start-->
                                <div v-if="nodeType=='05'">
                                    <v-card-text>
                                        <v-form
                                                ref="queryOfficeForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >
                                                <!--<v-col-->
                                                <!--cols="2"-->
                                                <!--xs="4"-->
                                                <!--&gt;-->
                                                <!--<z-source-selector-->
                                                <!--v-if="nodeType=='05'"-->
                                                <!--:label="'请选择医院'"-->
                                                <!--source="HospSelector"-->
                                                <!--:rules="[v => !!v||'医院必选']"-->
                                                <!--v-model="queryOfficeData.hospId">-->
                                                <!--</z-source-selector>-->

                                                <!--</v-col>-->

                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryOfficeData.deptName"
                                                            label="科室名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>


                                                <v-btn
                                                        color="primary"
                                                        :loading="loading.queryOfficeRequest"
                                                        @click="handleOfficeQuery"
                                                >
                                                    搜索
                                                    <v-icon right>mdi-magnify</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        color="primary"
                                                        class="ma-2"
                                                        @click="resetOfficeQuery"
                                                >
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>

                                            </v-row>
                                        </v-form>
                                        <v-row justify="center">
                                            <v-data-table
                                                    :options.sync="deptlistOptions"
                                                    :server-items-length="deptTotal"
                                                    v-model="selectOfficeId"
                                                    :headers="officeHeaders"
                                                    :items="dataTable.officeList"
                                                    :single-select="true"
                                                    item-key="id"
                                                    show-select
                                                    class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <!--添加科室 end-->

                                <!--添加房间 start-->
                                <div v-if="nodeType=='06'">
                                    <v-card-text>
                                        <v-form
                                                ref="queryRoomForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >
                                                <!--<v-col-->
                                                <!--cols="2"-->
                                                <!--xs="4"-->
                                                <!--&gt;-->

                                                <!--<z-source-selector-->
                                                <!--v-if="nodeType=='06'"-->
                                                <!--:label="'请选择医院'"-->
                                                <!--source="HospSelector"-->
                                                <!--:rules="[v => !!v||'医院必选']"-->
                                                <!--v-model="queryRoomData.hospId">-->
                                                <!--</z-source-selector>-->

                                                <!--</v-col>-->

                                                <!--<v-col-->
                                                <!--cols="2"-->
                                                <!--xs="4"-->
                                                <!--&gt;-->

                                                <!--<z-source-selector-->
                                                <!--v-if="nodeType=='06'"-->
                                                <!--:label="'请选择科室'"-->
                                                <!--source="DeptSelector"-->
                                                <!--:param="queryRoomData.hospId"-->
                                                <!--:rules="[v => !!v||'科室必选']"-->
                                                <!--v-model="queryRoomData.deptId">-->
                                                <!--</z-source-selector>-->

                                                <!--</v-col>-->

                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryRoomData.roomName"
                                                            label="房间名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>

                                                <v-btn
                                                        color="primary"
                                                        :loading="loading.queryRoomRequest"
                                                        @click="handleRoomQuery"
                                                >
                                                    搜索
                                                    <v-icon right>mdi-magnify</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        color="primary"
                                                        class="ma-2"
                                                        @click="resetRoomQuery"
                                                >
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>

                                            </v-row>
                                        </v-form>
                                        <v-row justify="center">
                                            <v-data-table
                                                    :options.sync="roomlistOptions"
                                                    :server-items-length="roomTotal"
                                                    v-model="selectRoomId"
                                                    :headers="roomHeaders"
                                                    :items="dataTable.roomList"
                                                    :single-select="true"
                                                    item-key="id"
                                                    show-select
                                                    class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <!--添加房间 end-->

                                <!--添加设备 start-->
                                <div v-if="nodeType=='07'">
                                    <v-card-text>
                                        <v-form
                                                ref="queryEqpForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >
                                                <!--<v-col-->
                                                <!--cols="2"-->
                                                <!--xs="4"-->
                                                <!--&gt;-->
                                                <!--<z-source-selector-->
                                                <!--v-if="nodeType=='07'"-->
                                                <!--:label="'请选择医院'"-->
                                                <!--source="HospSelector"-->
                                                <!--:rules="[v => !!v||'医院必选']"-->
                                                <!--v-model="queryEqpData.hospId">-->
                                                <!--</z-source-selector>-->

                                                <!--</v-col>-->

                                                <!--<v-col-->
                                                <!--cols="2"-->
                                                <!--xs="4"-->
                                                <!--&gt;-->

                                                <!--<z-source-selector-->
                                                <!--v-if="nodeType=='07'"-->
                                                <!--:label="'请选择科室'"-->
                                                <!--source="DeptSelector"-->
                                                <!--:param="queryEqpData.hospId"-->
                                                <!--:rules="[v => !!v||'科室必选']"-->
                                                <!--v-model="queryEqpData.realDeptId">-->
                                                <!--</z-source-selector>-->

                                                <!--</v-col>-->
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryEqpData.eqpName"
                                                            label="设备名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryEqpData.eqpBrand"
                                                            label="品牌"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryEqpData.factSerialNo"
                                                            label="出厂序列号"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryEqpData.hospEqpId"
                                                            label="设备编号"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>

                                                <v-btn
                                                        color="primary"
                                                        :loading="loading.queryEqpRequest"
                                                        @click="handleEqpQuery"
                                                >
                                                    搜索
                                                    <v-icon right>mdi-magnify</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        color="primary"
                                                        class="ma-2"
                                                        @click="resetEqpQuery"
                                                >
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>

                                            </v-row>
                                        </v-form>
                                        <v-row justify="center">
                                            <v-data-table
                                                    style="width:100%;"
                                                    :no-data-text="'无数据'"
                                                    :options.sync="eqplistOptions"
                                                    :server-items-length="eqpTotal"
                                                    v-model="selectEqpId"
                                                    :headers="eqpHeaders"
                                                    :items="dataTable.eqpList"
                                                    :single-select="true"
                                                    item-key="id"
                                                    show-select
                                                    class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <!--添加设备 end-->

                                <!--添加采集器 start-->
                                <div v-if="nodeType=='08'">
                                    <v-card-text>
                                        <v-form
                                                ref="queryCollectorForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.collectorSeq"
                                                            label="采集器编号"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.collectorName"
                                                            label="采集器名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.maxSensorCount"
                                                            label="支持节点数"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.collectorModel"
                                                            label="采集器型号"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.collectorMac"
                                                            label="采集器MAC"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col
                                                        cols="2"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            v-model="queryCollectorData.factSerialNo"
                                                            label="采集器序列号"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>

                                                <v-btn
                                                        color="primary"
                                                        :loading="loading.queryCollectorRequest"
                                                        @click="handleCollectorQuery"
                                                >
                                                    搜索
                                                    <v-icon right>mdi-magnify</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        color="primary"
                                                        class="ma-2"
                                                        @click="resetCollectorQuery"
                                                >
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>

                                            </v-row>
                                        </v-form>
                                        <v-row justify="center">
                                            <v-data-table
                                                    :options.sync="collectorlistOptions"
                                                    :server-items-length="collectorTotal"
                                                    v-model="selectCollectorId"
                                                    :headers="collectorHeaders"
                                                    :items="dataTable.collectorList"
                                                    :single-select="true"
                                                    item-key="id"
                                                    show-select
                                                    class="elevation-1"
                                            >
                                            </v-data-table>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <!--添加采集器 end-->

                                <!--添加自定义节点 start-->
                                <div v-if="nodeType=='09'">
                                    <v-card-text>
                                        <v-form
                                                ref="addCustomForm"
                                        >
                                            <v-row
                                                    justify="center"
                                                    align="center"
                                            >
                                                <v-col
                                                        cols="3"
                                                        xs="4"
                                                >
                                                    <v-text-field
                                                            clearable
                                                            required
                                                            :rules="[v => !!v || '节点名称必输']"
                                                            v-model="addCustomData.nodeIdName"
                                                            label="节点名称"
                                                            single-line
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                </div>
                                <!--添加自定义节点 end-->

                            </v-card>

                            <v-btn
                                    color="primary"
                                    @click='submitNodeDetail'
                            >
                                下一步
                            </v-btn>

                            <v-btn text @click="stepIndex = 1">上一步</v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="3" class="text-center">
                            <v-card
                                    style="width:95%"
                                    class="mx-auto ma-4"
                            >
                                <v-btn color="primary" class="mt-12 mb-12" fab x-large dark>
                                    <v-icon>done_all</v-icon>
                                </v-btn>
                            </v-card>

                            <v-btn
                                    color="primary"
                                    @click="closeAddDialog"
                            >
                                关闭
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </template>
        </v-dialog>
        <!--节点增加弹框 end-->

        <!--节点修改弹框 start-->
        <v-dialog
                v-model="dialog.update"
                width="500"
        >
            <v-card>
                <v-card-title>修改节点信息</v-card-title>
                <v-card-text>
                    <v-form ref="updateForm">
                        <v-text-field
                                v-model="updateFormData.nodeName"
                                :rules="[v => !!v || '节点名称必输',v => (v&&v.length<=30)||'长度不得超过30']"
                                :counter="30"
                                label="节点名"
                                required
                                clearable
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="text-center justify-center">
                    <v-btn text color="primary" @click="cancelUpdate">取消</v-btn>
                    <v-btn color="primary"
                           :loading="loading.updateNode"
                           @click="confirmUpdate">确定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--节点修改弹框 end-->


      <!--节点修改弹框 start-->
      <v-dialog
          v-model="dialog.remove"
          width="500"
      >
        <v-card>
          <v-card-title>是否删除节点</v-card-title>
          <v-card-text>
          </v-card-text>
          <v-card-actions class="text-center justify-center">
            <v-btn text color="primary" @click="cancelRemove">取消</v-btn>
            <v-btn color="primary"
                   :loading="loading.removeNode"
                   @click="confirmRemove">确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--节点修改弹框 end-->

        <z-notify ref="notify"></z-notify>

    </div>
</template>

<script>
  import {
    queryNodeTree,
    queryNodeSelector,
    queryNodeParentLabel,
    hospPageQuery,
    deptPageQuery,
    roomPageQuery,
    eqpPageQuery,
    collectorPageQuery,
    saveNodeInfo,
    savePlaceInfo,
    renameNodeUpdate,
    nodeRemove
  } from "@/api/tree"
  import ZSourceSelector from "@/components/ZSourceSelector"

  export default {
    name: "Tree",
    data: () => ({
      dialog: {
        addNode: false,
        update: false,
        remove: false
      },
      stepIndex: 1,
      loading: {
        queryRequest: false,
        queryHospRequest: false,
        queryOfficeRequest: false,
        queryRoomRequest: false,
        queryEqpRequest: false,
        queryCollectorRequest: false,
        updateNode: false,
        removeNode: false
      },
      parentNodeDesc: "",
      queryData: {
        nodeName: null,
      },
      areaListData: {
        province: '',
        city: '',
        district: ''
      },
      queryHospData: {
        hospName: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 2
        }
      },
      hosplistOptions: {},
      hospTotal: 0,
      deptlistOptions: {},
      deptTotal: 0,
      roomlistOptions: {},
      roomTotal: 0,
      eqplistOptions: {},
      eqpTotal: 0,
      collectorlistOptions: {},
      collectorTotal: 0,
      queryOfficeData: {
        hospId: '',
        deptName: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        }
      },
      queryRoomData: {
        hospId: '',
        deptId: '',
        roomName: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        }
      },
      queryEqpData: {
        hospId: '',
        deptId: '',
        realDeptId: '',
        eqpBrand: '',
        eqpModel: '',
        eqpName: '',
        factSerialNo: '',
        hospEqpId: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        }
      },
      queryCollectorData: {
        collectorSeq: '',
        collectorName: '',
        collectorMac: '',
        collectorModel: '',
        maxSensorCount: '',
        factSerialNo: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        }
      },
      addCustomData: {
        nodeIdName: ''
      },
      updateFormData: {
        nodeName: ''
      },
      currentUpdateNodeInfo: {},
      currentRemoveNodeInfo: {},
      nodeTypeList: [],
      nodeType: '',
      treeList: [],
      treeKeyList: [],
      activeKey: null,
      singleSelect: false,
      selected: [],
      hospHeaders: [
        {
          text: '医院编号',
          align: 'start',
          sortable: false,
          value: 'hospCode',
        },
        {
          text: '医院名称',
          align: 'start',
          sortable: false,
          value: 'hospName',
        }
      ],
      officeHeaders: [
        {
          text: '科室',
          align: 'start',
          sortable: false,
          value: 'deptName',
        }
      ],
      roomHeaders: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {
          text: '房间',
          align: 'start',
          sortable: false,
          value: 'roomName',
        }
      ],
      eqpHeaders: [
        {
          text: 'ID',
          align: 'start',
          width: '10%',
          sortable: false,
          value: 'id',
        },
        {
          text: '房间',
          align: 'start',
          sortable: false,
          value: 'roomName',
        },
        {
          text: '设备',
          align: 'start',
          sortable: false,
          value: 'eqpName',
        },
        {
          text: '品牌',
          align: 'start',
          sortable: false,
          value: 'eqpBrand',
        },
        {
          text: '出厂序列号',
          align: 'start',
          sortable: false,
          value: 'factSerialNo',
        },
        {
          text: '设备编号',
          align: 'start',
          sortable: false,
          value: 'hospEqpId',
        }
      ],
      collectorHeaders: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {
          text: '采集器编号',
          align: 'start',
          sortable: false,
          value: 'collectorSeq',
        },
        {
          text: '采集器名称',
          align: 'start',
          sortable: false,
          value: 'collectorName',
        },
        {
          text: '型号',
          align: 'start',
          sortable: false,
          value: 'collectorModel',
        },
        {
          text: 'MAC',
          align: 'start',
          sortable: false,
          value: 'collectorMac',
        },
        {
          text: '出厂序列号',
          align: 'start',
          sortable: false,
          value: 'factSerialNo',
        },
      ],
      dataTable: {
        hospList: [
          // {
          //   name: '医院1',
          //   calories: 159,
          // },
        ],
        officeList: [
          // {
          //   name: '科室',
          //   calories: 1,
          // },
        ],
        roomList: [
          // {
          //   name: '房间',
          //   calories: 1,
          // },
        ],
        eqpList: [
          // {
          //   name: '设备001',
          //   calories: 1,
          // },
        ],
        collectorList: [
          // {
          //   name: '采集器111',
          //   calories: 1
          // }
        ]
      },
      // 已选择医院id
      selectHospId: [],
      selectOfficeId: [],
      selectRoomId: [],
      selectEqpId: [],
      selectCollectorId: [],
      // 所有医院
      hospAllList: [],
      // 所有科室
      deptAllList: [],
      deptAllListEqpPage: [],
      isAddParentNode: false,
      currentBusinessId: '',
      open: ['public'],
    }),
    components: {
      ZSourceSelector
    },
    computed: {
      filter() {
        return (item, search, textKey) => item[textKey].indexOf(search) > -1 ? item : undefined;
      },
    },
    watch: {
      // 'queryRoomData.hospId': {
      //   handler(val) {
      //     console.log(val, "切换了医院");
      //     this.queryAllDept(val, '01');
      //   }
      // },
      // 'queryEqpData.hospId': {
      //   handler(val) {
      //     this.queryAllDept(val, '02');
      //   }
      // },

      // 医院的查询
      hosplistOptions: {
        handler(val, old) {
          console.log(val, '医院的hosplistOptions分页');
          if(val.itemsPerPage==-1){
            this.queryHospData.pagedQueryInfo.index =1;
            this.queryHospData.pagedQueryInfo.pageSize=999999;
          }else{
            this.queryHospData.pagedQueryInfo.index = val.page;
            this.queryHospData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.handleHospQuery();
        }
      },
      deptlistOptions: {
        handler(val) {
          console.log(val, '科室的hosplistOptions分页');
          if(val.itemsPerPage==-1){
            this.queryOfficeData.pagedQueryInfo.index =1;
            this.queryOfficeData.pagedQueryInfo.pageSize=999999;
          }else{
            this.queryOfficeData.pagedQueryInfo.index = val.page;
            this.queryOfficeData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.handleOfficeQuery();
        }
      },
      roomlistOptions: {
        handler(val) {
          console.log(val, '房间的hosplistOptions分页');
          if(val.itemsPerPage==-1){
            this.queryRoomData.pagedQueryInfo.index = 1;
            this.queryRoomData.pagedQueryInfo.pageSize =999999 ;
          }else{
            this.queryRoomData.pagedQueryInfo.index = val.page;
            this.queryRoomData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.handleRoomQuery();
        }
      },
      eqplistOptions: {
        handler(val) {
          console.log(val, '设备的hosplistOptions分页');
          if(val.itemsPerPage==-1){
            this.queryEqpData.pagedQueryInfo.index = 1;
            this.queryEqpData.pagedQueryInfo.pageSize = 999999;
          }else{
            this.queryEqpData.pagedQueryInfo.index = val.page;
            this.queryEqpData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.handleEqpQuery();
        }
      },
      collectorlistOptions: {
        handler(val) {
          console.log(val, '采集器的hosplistOptions分页');
          if(val.itemsPerPage==-1){
            this.queryCollectorData.pagedQueryInfo.index = 1;
            this.queryCollectorData.pagedQueryInfo.pageSize = 999999;
          }else{
            this.queryCollectorData.pagedQueryInfo.index = val.page;
            this.queryCollectorData.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          this.handleCollectorQuery();
        }
      }
    },
    methods: {
      // 重置增加弹框
      resetAddDialog() {
        !!this.$refs.chooseNodeTypeForm && this.$refs.chooseNodeTypeForm.reset();
        !!this.$refs.areaForm && this.$refs.areaForm.reset();
        !!this.$refs.queryHospForm && this.$refs.queryHospForm.reset();
        !!this.$refs.queryOfficeForm && this.$refs.queryOfficeForm.reset();
        !!this.$refs.queryRoomForm && this.$refs.queryRoomForm.reset();
        !!this.$refs.queryEqpForm && this.$refs.queryEqpForm.reset();
        !!this.$refs.queryCollectorForm && this.$refs.queryCollectorForm.reset();
        !!this.$refs.addCustomForm && this.$refs.addCustomForm.reset();

        this.dataTable.hospList = [];
        this.dataTable.officeList = [];
        this.dataTable.roomList = [];
        this.dataTable.eqpList = [];
        this.dataTable.collectorList = [];

        this.addCustomData.nodeIdName = '';
        this.areaListData = {
          province: '',
          city: '',
          district: ''
        };
        this.selectHospId = [];
        this.selectOfficeId = [];
        this.selectRoomId = [];
        this.selectEqpId = [];
        this.selectCollectorId = [];
      },
      closeAddDialog() {
        console.log('关闭reset');
        this.resetAddDialog();
        this.dialog.addNode = false;
        this.queryNodeTree();
        this.queryData.nodeName = '';
      },
      // 添加主节点
      addNode() {
        !this.isAddParentNode && this.resetAddDialog();
        this.isAddParentNode = true;
        // this.stepIndex = 1;
        // this.parentNodeDesc = '';
        // this.dialog.addNode = true;
        this.queryNodeSelector();
      },
      addChildNode() {
        console.log(this.activeKey, '当前选中的节点');
        if (!this.activeKey) {
          this.$refs.notify.show("请先选择节点", {timeout: 1000, color: 'error'})
        } else {
          this.isAddParentNode && this.resetAddDialog();
          this.isAddParentNode = false;
          // this.stepIndex = 1;
          // this.dialog.addNode = true;
          // this.queryNodeParentLabel(this.activeKey.id);
          this.queryNodeSelector(this.activeKey.nodeType);
        }
      },
      // 修改节点
      updateNode(item) {
        console.log(item, '当前选中的节点');
        this.currentUpdateNodeInfo = item;
        this.updateFormData.nodeName = item.nodeName;
        this.dialog.update = true;
      },
      // updateNode(){
      //   console.log(this.activeKey, '当前选中的节点');
      //   if (!this.activeKey) {
      //     this.$refs.notify.show("请先选择要修改的节点", {timeout: 1000, color: 'error'})
      //   } else if(this.activeKey.nodeType=='01'||this.activeKey.nodeType=='02'||this.activeKey.nodeType=='03'){
      //     this.$refs.notify.show("节点信息不允许修改", {timeout: 1000, color: 'error'})
      //   } else{
      //     this.currentUpdateNodeInfo=this.activeKey;
      //     this.updateFormData.nodeName=this.activeKey.nodeName;
      //     this.dialog.update=true;
      //   }
      // },

      cancelUpdate() {
        this.dialog.update = false;
      },
      confirmUpdate() {
        if (this.$refs.updateForm.validate()) {
          this.loading.updateNode = true;
          var req = {
            id: this.currentUpdateNodeInfo.id,
            nodeName: this.updateFormData.nodeName
          };
          renameNodeUpdate(req).then(res => {
            this.loading.updateNode = false;
            this.$refs.notify.show("修改成功",{timeout: 1000, color: 'green'});
            this.dialog.update = false;
            this.queryNodeTree();
          }).catch(err => {
            this.loading.updateNode = false;
          });
        }
      },

      // 删除节点
      removeNode(item) {
        console.log(item, '当前选中的节点');
        this.currentRemoveNodeInfo = item;
        this.dialog.remove = true;
      },
      cancelRemove() {
        this.dialog.remove = false;
      },
      confirmRemove() {
        this.loading.removeNode = true;
        var req = {
          id: this.currentRemoveNodeInfo.id,
        };
        nodeRemove(req).then(res => {
          this.loading.removeNode = false;
          this.$refs.notify.show("删除成功",{timeout: 1000, color: 'green'});
          this.dialog.remove = false;
          this.queryNodeTree();
        }).catch(err => {
          this.loading.removeNode = false;
        });
      },
      // 查找节点信息
      queryNodeSelector(nodeId) {
        var reqData = {
          parentNodeType: !nodeId ? '' : nodeId
        };
        queryNodeSelector(reqData).then(res => {
          this.nodeTypeList = res;
          this.stepIndex = 1;
          this.dialog.addNode = true;
          if (this.isAddParentNode) {
            this.parentNodeDesc = '';
          } else {
            this.queryNodeParentLabel(this.activeKey.id);
          }
        }).catch(err => {

        });
      },
      queryNodeParentLabel(nodeId) {
        var reqData = {
          nodeId: nodeId
        };
        queryNodeParentLabel(reqData).then(res => {
          this.parentNodeDesc = res;
        }).catch(err => {

        });
      },
      // 医院搜索
      handleHospQuery() {
        // alert(JSON.stringify(this.queryHospData) + '医院搜索');
        this.loading.queryHospRequest = true;
        hospPageQuery(this.queryHospData).then(res => {
          this.dataTable.hospList = res.list;
          this.hospTotal = res.total;
          this.loading.queryHospRequest = false;
        }).catch(err => {
          this.loading.queryHospRequest = false;
        })
      },
      // 重置医院搜索
      resetHospQuery() {
        // alert('重置医院搜索');
        this.$refs.queryHospForm.reset();
        this.handleHospQuery();
      },
      // 科室搜索
      handleOfficeQuery() {
        // alert(JSON.stringify(this.queryOfficeData) + '科室搜索');
        if (this.$refs.queryOfficeForm.validate()) {
          this.loading.queryOfficeRequest = true;
          deptPageQuery(this.queryOfficeData).then(res => {
            this.dataTable.officeList = res.list;
            this.deptTotal = res.total;
            this.loading.queryOfficeRequest = false;
          }).catch(err => {
            this.loading.queryOfficeRequest = false
          })
        }
      },
      // 重置科室搜索
      resetOfficeQuery() {
        this.$refs.queryOfficeForm.reset();
        this.dataTable.officeList = [];
        this.deptTotal = 0;
      },
      handleRoomQuery() {
        // alert(JSON.stringify(this.queryRoomData) + '房间搜索');
        if (this.$refs.queryRoomForm.validate()) {
          this.loading.queryRoomRequest = true;
          roomPageQuery(this.queryRoomData).then(res => {
            this.dataTable.roomList = res.list;
            this.roomTotal = res.total;
            this.loading.queryRoomRequest = false;
          }).catch(err => {
            this.loading.queryRoomRequest = false;
          });
        }
      },
      // 重置科室搜索
      resetRoomQuery() {
        this.$refs.queryRoomForm.reset();
        this.dataTable.roomList = [];
        this.roomTotal = 0;
      },
      handleEqpQuery() {
        if (this.$refs.queryEqpForm.validate()) {
          this.loading.queryEqpRequest = true;
          eqpPageQuery(this.queryEqpData).then(res => {
            this.dataTable.eqpList = res.list;
            this.eqpTotal = res.total;
            this.loading.queryEqpRequest = false;
          }).catch(err => {
            this.loading.queryEqpRequest = false;
          });
        }
      },
      resetEqpQuery() {
        this.$refs.queryEqpForm.reset();
        this.dataTable.eqpList = [];
        this.eqpTotal = 0;
      },
      handleCollectorQuery() {
        this.loading.queryCollectorRequest = true;
        collectorPageQuery(this.queryCollectorData).then(res => {
          this.dataTable.collectorList = res.list;
          this.collectorTotal = res.total;
          this.loading.queryCollectorRequest = false;
        }).catch(err => {
          this.loading.queryCollectorRequest = false;
        });
      },
      resetCollectorQuery() {
        this.$refs.queryCollectorForm.reset();
        this.dataTable.collectorList = [];
        this.collectorTotal = 0;
      },
      updateActiveKey(list) {
        this.activeKey = list[0];
        console.log(this.activeKey, '当前激活的节点');
      },
      showNodeDetail() {
        console.log(this.activeKey, "显示节点详情");
      },
      goNodeDetail() {
        if (this.$refs.chooseNodeTypeForm.validate()) {
          this.stepIndex++;

          if (this.nodeType == '02') {
            this.areaListData.province = this.activeKey.businessId;
          }
          if (this.nodeType == '03') {
            this.areaListData.city = this.activeKey.businessId;
          }

          if (!this.activeKey || this.isAddParentNode) {
            return;
          }

          if (this.nodeType == '05' && this.activeKey.nodeType == '04') {
            this.queryOfficeData.hospId = this.activeKey.businessId;
          }

          if (this.nodeType == '06' && this.activeKey.nodeType == '05') {
            this.queryRoomData.deptId = this.activeKey.businessId;
          }

          if (this.nodeType == '07' && this.activeKey.nodeType == '05') {
            this.queryEqpData.deptId = this.activeKey.id;
          }

          if (this.nodeType == '07' && this.activeKey.nodeType == '06') {
            this.queryEqpData.deptId = this.activeKey.parentId;
          }

        }
      },
      // 查询所有医院
      queryAllHosp() {
        var reqData = {
          hospName: '',
          pagedQueryInfo: {
            index: 1,
            pageSize: 999999
          }
        };
        hospPageQuery(reqData).then(res => {
          this.hospAllList = res.list;
        });
      },
      queryAllDept(val, str) {
        var reqData = {
          deptName: "",
          hospId: val,
          pagedQueryInfo: {
            index: 1,
            pageSize: 999999
          }
        };
        deptPageQuery(reqData).then(res => {
          if (str == '01') {
            this.deptAllList = res.list;
          } else if (str == '02') {
            this.deptAllListEqpPage = res.list;
          }
        }).catch(err => {

        })
      },
      submitNodeDetail() {
        if (this.nodeType == '01' || this.nodeType == '02' || this.nodeType == '03') {
          console.log(this.areaListData, '选择的省市区信息');
          if (this.$refs.areaForm.validate()) {
            console.log(this.nodeType, '当前节点类型')
            var reqData = {
              // 父节点id
              nodeId: this.isAddParentNode ? '' : this.activeKey.id,
              // 省id
              provinceId: !this.isAddParentNode && (this.nodeType == '01' || this.nodeType == '02' || this.nodeType == '03') ? '' : this.areaListData.province,
              // 市id
              cityId: this.nodeType == '03' ? '' : this.areaListData.city,
              // 区id
              districtId: this.areaListData.district
            };
            savePlaceInfo(reqData).then(res => {
              this.resetAddDialog();
              this.stepIndex++;
            }).catch(err => {

            });
          }
        } else if (this.nodeType == '04') {
          console.log(this.selectHospId);
          if (this.selectHospId.length < 1) {
            this.$refs.notify.show("未选择医院", {timeout: 1000, color: 'error'})
          } else {
            this.saveNodeInfo(this.selectHospId[0].id, this.selectHospId[0].hospName,this.selectHospId[0].latitude,this.selectHospId[0].longitude);
          }
        } else if (this.nodeType == '05') {
          console.log(this.selectOfficeId);
          if (this.selectOfficeId.length < 1) {
            this.$refs.notify.show("未选择科室", {timeout: 1000, color: 'error'})
          } else {
            // 接口调用
            this.saveNodeInfo(this.selectOfficeId[0].id, this.selectOfficeId[0].deptName);
          }
        } else if (this.nodeType == '06') {
          console.log(this.selectRoomId);
          if (this.selectRoomId.length < 1) {
            this.$refs.notify.show("未选择房间", {timeout: 1000, color: 'error'})
          } else {
            // 接口调用
            this.saveNodeInfo(this.selectRoomId[0].id, this.selectRoomId[0].roomName);
          }
        } else if (this.nodeType == '07') {
          console.log(this.selectEqpId);
          if (this.selectEqpId.length < 1) {
            this.$refs.notify.show("未选择设备", {timeout: 1000, color: 'error'})
          } else {
            // 接口调用
            this.saveNodeInfo(this.selectEqpId[0].id, this.selectEqpId[0].eqpName);
          }
        } else if (this.nodeType == '08') {
          if (this.selectCollectorId.length < 1) {
            this.$refs.notify.show("未选择采集器", {timeout: 1000, color: 'error'})
          } else {
            // 接口调用
            this.saveNodeInfo(this.selectCollectorId[0].id, this.selectCollectorId[0].collectorName);
          }
        } else if (this.nodeType == '09') {
          if (this.$refs.addCustomForm.validate()) {
            // 接口调用
            this.saveNodeInfo('', this.addCustomData.nodeIdName);
          }
        }

      },
      saveNodeInfo(id,name,latitude,longitude) {
        // alert(name);
        var reqData = {
          // 父节点id
          nodeId: this.isAddParentNode ? '' : this.activeKey.id,
          // 业务id
          businessId: id,
          // 节点名
          nodeName: name,
          // 节点类型
          nodeTypeCode: this.nodeType,
        };

        if(this.nodeType=='04'){
          // alert("医院类型");
          reqData.latitude=latitude;
          reqData.longitude=longitude;
        }

        saveNodeInfo(reqData).then(res => {
          this.resetAddDialog();
          this.stepIndex++;
          // alert(this.stepIndex+"this.stepIndex");
        }).catch(err => {

        });
      },
      // 查询树节点
      queryNodeTree() {
        queryNodeTree({}).then(res => {
          var str = JSON.stringify(res);
          str = str.replace(/\,\"childNodeList\"\:null/g, '');
          res = JSON.parse(str);
          this.treeList = res;
        }).catch(err => {

        });
      },
    },
    created() {
      this.queryNodeTree();
    }
  }
</script>

<style scoped>

</style>